import { axios } from '@/utils/request'

export function userStatistics (parameter = {}) {
  return axios({
    url: '/telemarket/user/statistics',
    method: 'post',
    data: parameter
  })
}

export function manualLoadData (parameter = {}) {
  return axios({
    url: '/telemarket/manual/loadData',
    method: 'post',
    data: parameter
  })
}

export function dataList (parameter = {}) {
  return axios({
    url: '/telemarket/data/list',
    method: 'post',
    data: parameter
  })
}

export function dataDetail (id) {
  return axios({
    url: '/telemarket/data/detail/' +id,
    method: 'get'
  })
}

export function dataCount (parameter = {}) {
  return axios({
    url: '/telemarket/data/count',
    method: 'post',
    data: parameter
  })
}


export function teleMarketUsers () {
  return axios({
    url: '/telemarket/users',
    method: 'get'
  })
}

export function baseData () {
  return axios({
    url: '/telemarket/baseData',
    method: 'get'
  })
}

// Recovery
export function recycle (parameter = {}) {
  return axios({
    url: '/telemarket/recycle',
    method: 'post',
    data: parameter
  })
}

// Reassign
export function reAssign (parameter = {}) {
  return axios({
    url: '/telemarket/reAssign',
    method: 'post',
    data: parameter
  })
}

//Seat operation
export function seatList(parameter = {}) {
  return axios({
    url: '/telemarket/seat/list',
    method: 'post',
    data: parameter
  })
}

export function seatOperate(parameter = {}) {
  return axios({
    url: '/telemarket/seat/opt',
    method: 'post',
    data: parameter
  })
}

export function seatDelete(id) {
  return axios({
    url: '/telemarket/seat/delete/' + id,
    method: 'get'
  })
}

// Report
export function efficiency(parameter = {}) {
  return axios({
    url: '/telemarket/report/efficiency',
    method: 'post',
    data: parameter
  })
}

export function t1Convert(parameter = {}) {
  return axios({
    url: '/telemarket/report/t1Convert',
    method: 'post',
    data: parameter
  })
}

export function t0t7Convert(parameter = {}) {
  return axios({
    url: '/telemarket/report/t0t7Convert',
    method: 'post',
    data: parameter
  })
}

export function followUp(parameter = {}){
  return axios({
    url: '/telemarket/data/followUp',
    method: 'post',
    data: parameter
  })
}

export function upload(parameter = {}){
  return axios({
    url: '/telemarket/upload',
    method: 'post',
    data: parameter
  })
}
export function unbindClousSeat(mobile) {
  return axios({
    url: '/telemarket/seat/unbindClousSeat/' + mobile,
    method: 'get'
  })
}

export function assignRecordList(parameter = {}) {
  return axios({
    url: '/telemarket/assign/record/list',
    method: 'post',
    data: parameter
  })
}

export function assignConfigList(parameter = {}) {
  return axios({
    url: '/telemarket/assign/config/list',
    method: 'post',
    data: parameter
  })
}

export function assignConfigOperate(parameter = {}) {
  return axios({
    url: '/telemarket/assign/config/opt',
    method: 'post',
    data: parameter
  })
}

export function assignConfigDelete(id) {
  return axios({
    url: '/telemarket/assign/config/delete/' + id,
    method: 'get'
  })
}

export function userGroupBaseData() {
  return axios({
    url: '/telemarket/userGroup/baseData',
    method: 'get'
  })
}

export function userGroupList(parameter = {}) {
  return axios({
    url: '/telemarket/userGroup/list',
    method: 'post',
    data: parameter
  })
}


export function changeStatus(parameter = {}) {
  return axios({
    url: '/telemarket/userGroup/changeStatus',
    method: 'post',
    data: parameter
  })
}

export function userGroupOperate(parameter = {}) {
  return axios({
    url: '/telemarket/userGroup/opt',
    method: 'post',
    data: parameter
  })
}

export function userGroupDelete(id) {
  return axios({
    url: '/telemarket/userGroup/delete/' + id,
    method: 'get'
  })
}

export function storeTypeConfig (parameter = {}) {
  return axios({
    url: '/telemarket/storeTypeConfig',
    method: 'post',
    data: parameter
  })
}

export function callReport (parameter = {}) {
  return axios({
    url: '/telemarket/report/callReport',
    method: 'post',
    data: parameter
  })
}
export function t0Convert(parameter = {}) {
  return axios({
    url: '/telemarket/report/t0Convert',
    method: 'post',
    data: parameter
  })
}

export function userReport(parameter = {}) {
  return axios({
    url: '/telemarket/report/userReport',
    method: 'post',
    data: parameter
  })
}
export function assignConfigEditNew(parameter = {}) {
  return axios({
    url: '/telemarket/assign/config/editNew',
    method: 'post',
    data: parameter
  })
}

export function typeReport(parameter = {}) {
  return axios({
    url: '/telemarket/report/typeReport',
    method: 'post',
    data: parameter
  })
}

export function smsTemplateList(parameter = {}) {
  return axios({
    url: '/telemarket/smsTemplate/list',
    method: 'post',
    data: parameter
  })
}

export function smsTemplateOpt(parameter = {}) {
  return axios({
    url: '/telemarket/smsTemplate/opt',
    method: 'post',
    data: parameter
  })
}

export function smsTemplateDelete(id) {
  return axios({
    url: '/telemarket/smsTemplate/delete/' + id,
    method: 'get'
  })
}

export function autoGen () {
  return axios({
    url: '/telemarket/seat/autoGen',
    method: 'get'
  })
}

export function seatOperate2(parameter = {}) {
  return axios({
    url: '/telemarket/seat/opt2',
    method: 'post',
    data: parameter
  })
}

export function seatDelete2(id, userId) {
  return axios({
    url: '/telemarket/seat/delete2/' + id + '/' + userId,
    method: 'get'
  })
}

export function dataNumList(parameter = {}) {
  return axios({
    url: '/telemarket/dataNum/list',
    method: 'post',
    data: parameter
  })
}

export function dataNumBaseData() {
  return axios({
    url: '/telemarket/dataNum/baseData',
    method: 'get'
  })
}

export function userNumList(parameter = {}) {
  return axios({
    url: '/telemarket/userNum/list',
    method: 'post',
    data: parameter
  })
}

export function userNumBaseData() {
  return axios({
    url: '/telemarket/userNum/baseData',
    method: 'get'
  })
}

export function userGroupTypeConfigList(parameter = {}) {
  return axios({
    url: '/telemarket/userGroup/typeConfig/list',
    method: 'post',
    data: parameter
  })
}

export function userGroupTypeConfigEdit(parameter = {}) {
  return axios({
    url: '/telemarket/userGroup/typeConfig/opt',
    method: 'post',
    data: parameter
  })
}

export function taskListPre() {
  return axios({
    url: '/telemarket/third/taskListPre',
    method: 'get'
  })
}

export function taskConfigList(parameter = {}) {
  return axios({
    url: '/telemarket/third/taskConfigList',
    method: 'post',
    data: parameter
  })
}

export function taskConfigOpt(parameter = {}) {
  return axios({
    url: '/telemarket/third/taskConfigOpt',
    method: 'post',
    data: parameter
  })
}

export function followUpRecordBaseData () {
  return axios({
    url: '/telemarket/followUpRecord/baseData',
    method: 'get'
  })
}

export function followUpRecordList(parameter = {}) {
  return axios({
    url: '/telemarket/followUpRecord/list',
    method: 'post',
    data: parameter
  })
}

export function relationListPre() {
  return axios({
    url: '/telemarket/third/relationListPre',
    method: 'get'
  })
}

export function relationOpt(parameter = {}) {
  return axios({
    url: '/telemarket/third/relationOpt',
    method: 'post',
    data: parameter
  })
}